import Helper from "@ember/component/helper";
import { service } from "@ember/service";
import type IntlService from "ember-intl/services/intl";
import { compute as jeSourceCompute } from "parog-web/helpers/je-source";
import type BioExamResultsReceivedJournalEvent from "parog-web/models/bio-exam-results-received-journal-event";

export default class extends Helper {
  @service declare intl: IntlService;

  compute([bioExamResultsJe]: [BioExamResultsReceivedJournalEvent]) {
    if (bioExamResultsJe.isFromHprim) return "via Apicrypt";
    if (bioExamResultsJe.isFromOru) return "via HL7";
    if (bioExamResultsJe.hlaId) return "via connecteur HLA";
    return jeSourceCompute([bioExamResultsJe], this.intl);
  }
}
